import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const ContentSection = ({ title, content, className = "", theme = "dark" }) => {
  const { t } = useTranslation();

  const isDark = theme === 'dark';
  const defaultBg = isDark ? 'bg-slate-900' : 'bg-white';
  const textColor = isDark ? 'text-slate-300' : 'text-slate-600';
  const titleColor = isDark ? 'text-white' : 'text-slate-900';

  // Use passed className or defaultBg if not provided
  const sectionBg = className.includes('bg-') ? className : `${defaultBg} ${className}`;

  const renderContent = () => {
    if (Array.isArray(content)) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                {content.map((paragraph, index) => (
                    <div key={index} className="relative p-8 rounded-2xl bg-slate-800/20 border border-slate-700/50 hover:bg-slate-800/40 hover:border-cyan-500/20 transition-all duration-300 group">
                        <div className="text-6xl font-bold text-slate-800 group-hover:text-cyan-500/10 transition-colors duration-300 font-sans absolute top-4 right-6 select-none">
                            {String(index + 1).padStart(2, '0')}
                        </div>
                        <div className="relative z-10">
                            <p className={`text-lg leading-relaxed ${textColor}`}>
                                {paragraph}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
    
    return (
        <div className={`prose prose-lg ${isDark ? 'prose-invert' : ''} mx-auto max-w-3xl text-center`}>
           <p className={`text-lg leading-relaxed ${textColor}`}>{content}</p>
        </div>
    );
  };

  return (
    <section className={`py-24 ${sectionBg}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {title && (
            <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-6 ${titleColor}`}>
              {title}
            </h2>
          )}
        </div>
        {renderContent()}
      </div>
    </section>
  );
};

export default ContentSection;